import { useState, useEffect } from "react";
import LogBlock from "./logBlock/LogBlock";
import Logo from "./logo/Logo";
import MobileMenu from "./navMenu/MobileMenu";
import Nav from "./nav/Nav";
import { SvgAtras, SvgLupa } from "@/icons";
import Alerta from "../alert/Alerta";
import { useNavigate, useLocation } from "react-router-dom";


function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);
  const [showSearch, setShowSearch] = useState(false);
  const [showLogoutAlert, setShowLogoutAlert] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const canGoBack = window.history.length > 1;
  const showBackButton = canGoBack && location.pathname !== "/";
  const isLanding = location.pathname.startsWith("/landing");

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    const handleResize = () => {
      const isNowMobile = window.innerWidth < 1024;
      const isNowLandscape = window.innerWidth > window.innerHeight;
      setIsMobile(isNowMobile);
      setIsLandscape(isNowLandscape);
      if (!isNowMobile || (isNowMobile && isNowLandscape)) {
        setIsMobileMenuOpen(false);
        setShowSearch(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "auto";
  }, [isMobileMenuOpen]);


    if (isLanding) {
    return null;
  }

  return (
    <header
      className={`fixed w-screen top-0 z-20 shadow-md duration-300 ${scrolled ? "bg-white/90 backdrop-blur-md" : "bg-white"
        }`}
    >
      <div className="grid grid-cols-[auto_1fr_auto] items-center w-full py-2 px-2 md:px-6 gap-3">

        {/* Logo + Back (misma columna) */}
        <div className="flex items-center gap-1">
          <Logo />

          {showBackButton && (
            <button
              onClick={() => navigate(-1)}
              className="ml-4 rounded-l-xl rounded-r-xl text-zinc-600 bg-zinc-400 hover:text-zinc-900 transition"
              aria-label="Volver"
              title="Volver"
            >
             <SvgAtras/>
            </button>
          )}
        </div>

        {/* NAV / SEARCH */}
        <div className="flex justify-center w-full">
          {!isMobile ? (
            <Nav />
          ) : (
            <button
              onClick={() => setShowSearch(true)}
              className="p-2 text-zinc-700"
            >
              <SvgLupa />
            </button>
          )}
        </div>

        {/* Columna derecha */}
        {!isMobile && (
          <LogBlock onLogout={() => setShowLogoutAlert(true)} />
        )}

        {isMobile && !isLandscape && (
          <div className="flex justify-end">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
              <img src="/icons/hambur.png" alt="Menú" className="h-10 w-12" />
            </button>
          </div>
        )}
      </div>


      {/* 🔹 Menú lateral móvil */}
      {isMobile && (
        <>
          {isMobileMenuOpen && (
            <div
              className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"
              onClick={() => setIsMobileMenuOpen(false)}
            />
          )}
          <MobileMenu
            isOpen={isMobileMenuOpen}
            onClose={() => setIsMobileMenuOpen(false)}
          />
        </>
      )}

      {/* 🔹 Buscador desplegable móvil */}
      {isMobile && showSearch && (
        <div className="fixed inset-0 z-50 flex flex-col bg-white p-4 animate-[fadeIn_0.3s_ease]">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-zinc-800">Buscar</h3>
            <button
              onClick={() => setShowSearch(false)}
              className="text-zinc-600 text-sm px-3 py-1"
            >
              Cerrar ✕
            </button>
          </div>

          <Nav
            mobileMode
            onCloseMobile={() => setShowSearch(false)}
          />
        </div>
      )}

      {showLogoutAlert && (
        <Alerta
          mensaje="Has cerrado sesión correctamente"
          type="success"
          onClose={() => setShowLogoutAlert(false)}
        />
      )}

    </header>
  );
}

export default Header;
